"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = decodeAccessToken;
const constants_1 = require("../constants");
const utils_1 = require("../utils");
function decodeToken(encodedUserInfo) {
    if (!encodedUserInfo) {
        return {};
    }
    try {
        const buffer = Buffer.from(encodedUserInfo, 'base64');
        const decodedString = buffer.toString('utf8');
        return JSON.parse(decodedString);
    }
    catch (error) {
        return {};
    }
}
/**
 * Decodes user information from x-access-token if found in request header and injects it into req.user
 */
function decodeAccessToken(useAzureAd = false) {
    return async (req, res, next) => {
        const accessToken = req.headers[constants_1.RequestHeaders.AccessToken];
        if (accessToken?.length) {
            if (!useAzureAd) {
                const [, userInfoToken] = accessToken.split('.');
                const { userId, organizationId } = decodeToken(userInfoToken);
                req.session.userId = userId;
                req.user = { userId, organizationId };
            }
            else {
                try {
                    // Users logged in with AzureAD would need to be fetched from database based on their access token
                    // as the accessToken itself does not have a direct mapping of the user's id
                    // Fetching user on every request can impact performance, hence storing userId into session in the first fetch is required
                    if (!req.session.userId) {
                        const { data: user } = await (0, utils_1.sendAxiosGetRequest)((0, utils_1.getApiUrl)('/users/api/v1/me'), {
                            Authorization: `Bearer ${accessToken}`,
                        });
                        req.session.userId = user.id;
                    }
                    req.user = { userId: req.session.userId };
                }
                catch (err) {
                    console.error('Retrieving user metadata failed..');
                    res.sendStatus(401);
                    return;
                }
            }
        }
        next();
    };
}
